module.exports = __webpack_public_path__ + "static/media/ckn_pedidos_estatus.b2651218.jpg";